import React from "react";
import {ApolloContext, State} from "./Apollo_Context";
import {ApolloMessage} from "./Apollo_Mesasge";

export interface AuthProps {
  role: number;
}

export interface ProfileProps {
  role: number;
  profile: number;
}
export interface ProfileProps2 {
  role: number;
  profile: number;
  isDisplay: boolean;
}

// ロール情報
export let APOLLO_SYSTEM_ADMIN = 99
export let APOLLO_SYSTEM_OPERATOR = 90
export let APOLLO_GROUP_ADMIN = 20
export let APOLLO_GROUP_OPERATOR = 10
export let APOLLO_GROUP_READER = 1
// ユーザ情報
export let APOLLO_PROFILE_USER = 0
export let APOLLO_PROFILE_SYSTEM_ADMIN = 1
export let APOLLO_PROFILE_SYSTEM_OPERATOR = 2

export const ApolloAuthorization: React.FC<AuthProps> = ({role, ...props}) => {

  const {state} = React.useContext(ApolloContext)

  return (
    <div>
      {
        (state.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_ADMIN || state.current.roleAuthorization >= role) ? props.children : ""
      }
    </div>
  );
};

export const ApolloUserProfileAuth: React.FC<ProfileProps> = ({role, profile, ...props}) => {

  const {state} = React.useContext(ApolloContext)

  return (
    <div>
      {
        state.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_ADMIN ? props.children
        // : state.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_OPERATOR ? profile === APOLLO_PROFILE_SYSTEM_OPERATOR ? props.children : ""
        // : state.current.roleAuthorization >= role ? props.children : ""
        : state.current.roleAuthorization >= role ? props.children
        : state.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_OPERATOR ? profile === APOLLO_PROFILE_SYSTEM_OPERATOR ? props.children : "" : ""
      }
    </div>
  );
};

export const ApolloPageUsagePermission: React.FC<ProfileProps> = ({role, profile, ...props}) => {

  const {data, setmsg} = React.useContext(ApolloMessage);
  const isAuthorization = IsAuthorization(role, profile);

  React.useEffect(() => {
    if (!isAuthorization) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "遷移先画面へのアクセス権限がありません。"
        }
      });
    }
  }, []);

  return (
    <div>
      {
        isAuthorization ? props.children : ""
      }
    </div>
  );
};

// Zeus: 広告グループ編集・作成、広告編集・作成、キャンペーン編集・作成
// 編集と作成で利用可能な範囲が異なる画面で使用
export const ApolloPageUsagePermission2: React.FC<ProfileProps2> = ({role, profile, isDisplay, ...props}) => {

  const {data, setmsg} = React.useContext(ApolloMessage);
  const isAuthorization = IsAuthorization(role, profile);

  React.useEffect(() => {
    if (!isAuthorization && !isDisplay) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "遷移先画面へのアクセス権限がありません。"
        }
      });
    }
  }, []);

  return (
    <div>
      {
        isDisplay ? props.children
        : isAuthorization ? props.children : ""
      }
    </div>
  );
};

export const IsAuthorization = (role: number, profile: number) => {

  const {state} = React.useContext(ApolloContext)

  // if (profile === 0) {
  //   return (
  //     (state.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_ADMIN || state.current.roleAuthorization >= role) ? true : false
  //   )
  // }

  return (
    state.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_ADMIN ? true
    // : state.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_OPERATOR ? profile === APOLLO_PROFILE_SYSTEM_OPERATOR ? true : false
    // : state.current.roleAuthorization >= role ? true : false
    : state.current.roleAuthorization >= role ? true
    : state.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_OPERATOR ? profile === APOLLO_PROFILE_SYSTEM_OPERATOR ? true : false : false
  )
}

// キャンペーン等の作成・編集権限をもつか確認
export const getEditPermission = function (state: State): boolean {

  // システム管理権限(D2Cロール)なら権限有
  if(state.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_ADMIN) return true;

  // アカウントグループ毎に設定された権限が管理権限、運用権限であれば権限有
  return state.current.roleAuthorization >= APOLLO_GROUP_OPERATOR;
}

// アカウントグループIDをキーにロール情報を取得する
// アカウントグループのロールを保持していない場合は、0 を返却する
export const getAuthorization = (state: State, accountGroupId: number) => {

  var result = 0;
  const auth = state.authorization.find((v) => v.accountGroup === accountGroupId);
  if (auth) {
    result = auth.roleAuthorization
  }
  return result;
}

// アカウントグループのロール権限有無を判定する (権限あり:true, 権限なし:false)
// システム管理権限以外は、ロール権限で判定する
export const IsAccountGroupAuth = (accountGroupId: number, role: number) => {

  const {state} = React.useContext(ApolloContext);

  // アカウントグループIDをキーにロール情報を取得する
  const groupAuth = getAuthorization(state, accountGroupId);

  return (
    state.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_ADMIN ? true
    : groupAuth >= role ? true : false
  )
}
